import { ProposalApi } from '@src/shared/api';
import { ApiError, CheckProposalStatus, Proposal } from '@src/shared/models';
import { useAppStore, setLoanSimulation } from '@src/shared/zustand/';
import { observability } from '@src/config/observability';

export const shouldLoading = () =>
  useAppStore.setState((state) => ({
    proposal: { ...state.proposal },
    loading: true,
  }));

export const pauseLoading = () =>
  useAppStore.setState((state) => ({
    proposal: { ...state.proposal },
    loading: false,
  }));

export const setProposalId = (proposalId: string) =>
  useAppStore.setState((state) => ({
    proposal: { ...state.proposal, proposalId },
  }));

export const setProposal = (proposal: Proposal, callback?: () => void) => {
  useAppStore.setState({ proposal, loading: false });

  // Set Bugsnag user context with proposal ID and user data
  if (proposal?.proposalId) {
    observability.setUser(
      proposal.proposalId,
      proposal.personalData?.email,
      proposal.personalData?.name
    );
  }

  callback?.();
};

export const getProposal = async (
  proposalId: string,
  callback: (error: ApiError | null, proposal: Proposal | null) => void
) => {
  shouldLoading();
  try {
    const data = await ProposalApi.getProposal(proposalId);

    const loanSimulation = data.loanSimulation?.find(
      (item) => item.recommended
    );

    if (loanSimulation) {
      setLoanSimulation(loanSimulation);
    }

    setProposal(data);

    callback(null, data);
  } catch (error) {
    callback(error, null);
  }
};

export const checkProposal = async (
  proposalId: string,
  callback: (error: ApiError | null, status: CheckProposalStatus | null) => void
) => {
  try {
    const data = await ProposalApi.checkProposal(proposalId);

    callback(null, data.status);
  } catch (error) {
    callback(error, null);
  }
};

export const retryCheckProposal = async (
  proposalId: string,
  callback: (error: ApiError | null, status: CheckProposalStatus | null) => void
) => {
  try {
    const data = await ProposalApi.retryCheckProposal(proposalId);

    callback(null, data.status);
  } catch (error) {
    callback(error, null);
  }
};
